import { Icon } from '@chakra-ui/react'

export const RadioWhite = (props: any) => (
  <Icon boxSize={props.boxSize || '20px'} {...props} viewBox="0 0 8 8" fill="none">
    <rect rx="4" fill="white"/>
  </Icon>
)


export const RadioWhiteString=`<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="8" height="8" rx="4" fill="white"/>
</svg>
`